import { supportsBackgroundProcessors } from '@livekit/track-processors';
let cachedSupport = null;
/**
 * LiveKit's supportsBackgroundProcessors() creates a temporary WebGL2 context
 * on every call. Cache once — otherwise Meet re-renders exhaust the browser
 * WebGL context limit ("too many active WebGL contexts").
 */
export function getSupportsBackgroundProcessors() {
    if (typeof window === 'undefined') {
        return false;
    }
    if (cachedSupport === null) {
        cachedSupport = supportsBackgroundProcessors();
    }
    return cachedSupport;
}
